import { createState } from '~/util/storeHelpers'

const userMessages = createState({ key: 'userMessages', initialValue: [] })
export const state = () => ({
  userMessages: userMessages.state,
  userMessagesMark: [],
  userMessagesRemove: [],
})

export const mutations = {
  set_userMessages: (state, { data, isLoading, error, reset }) => {
    if (data) {
      data = data.sort((a, b) => b.is_new - a.is_new)
    }
    userMessages.setter(state, { data, isLoading, error, reset })
  },
  set_userMessagesMark: (state, { userMessagesMark }) => {
    state.userMessagesMark = userMessagesMark
  },
  set_userMessagesRemove: (state, { userMessagesRemove }) => {
    state.userMessagesRemove = userMessagesRemove
  },
}

export const actions = {
  async fetch_userMessages ({ commit }, data) {
    commit('set_userMessages', { isLoading: true })
    const res = await this.$api.userMessages.list({ lang: data })
    commit('set_userMessages', { data: res.data.data })
    commit('set_userMessages', { isLoading: false })
  },
  async fetch_userMessagesMark ({ commit }, data) {
    const res = await this.$api.userMessages.markAsRead({ uuid: data.uuid })
    commit('set_userMessagesMark', { userMessagesMark: res.data })
  },
  async fetch_userMessagesRemove ({ commit }, data) {
    const res = await this.$api.userMessages.remove({ uuid: data.uuid })
    commit('set_userMessagesRemove', { userMessagesRemove: res.data })
  },
}

export const getters = {
  get_userMessages: userMessages.getter,
  get_userMessagesGroups: (state) => {
    return state.userMessages.data.reduce((result, message) => {
      const date = message.created_date?.split(' ')?.[0]

      if (date) {
        if (!result[date]) {
          result[date] = []
        }
        result[date].push(message)
      }

      return result
    }, {})
  },
  get_userMessagesRemove: state => state.userMessagesRemove,
  get_newUserMessagesLength: state => state.userMessages.data.filter(message => message.is_new).length,
}
